export default __webpack_public_path__ + "media/images/icons/car-solid-33aecd1795ed8fb1dcdace220e36b53f.svg";